import React from 'react';

export default function statusBar(status, css) {
  switch (status?.toLowerCase()) {
    case 'pending':
      return (
        <div className={css.progressBarEmpty}>
          <div className={`${css.progressBarStart} ${css.yellow}`}></div>
        </div>
      );
    case 'draft':
      return <div className={css.progressBarEmpty}></div>;
    case 'created':
      return (
        <div className={css.progressBarEmpty}>
          <div className={`${css.progressBarStart} ${css.grey}`}></div>
        </div>
      );
    case 'completed':
      return (
        <div className={css.progressBarEmpty}>
          <div className={css.progressBarFull}></div>
        </div>
      );
    case 'sent':
      return (
        <div className={css.progressBarEmpty}>
          <div className={`${css.progressBarStart} ${css.orange}`}></div>
        </div>
      );
    case 'cancelled':
      return (
        <div className={css.progressBarEmpty}>
          <div className={css.progressBarFullCancelled}></div>{' '}
        </div>
      );
    case 'error':
      return <div className={css.progressBarFullError}></div>;
    case 'awaiting wire':
      return (
        <div className={css.progressBarEmpty}>
          <div className={css.progressBarThreeQuarter}></div>
        </div>
      );
    case 'awaiting approval':
      return (
        <div className={css.progressBarEmpty}>
          <div className={css.progressBarThreeQuarter}></div>{' '}
        </div>
      );
    case 'requested':
      return (
        <div className={css.progressBarEmpty}>
          <div className={css.progressBarStart}></div>
        </div>
      );
  }
}
